import { render, staticRenderFns } from "./ChainStagesEditor.vue?vue&type=template&id=22a30096&scoped=true"
import script from "./ChainStagesEditor.vue?vue&type=script&lang=js"
export * from "./ChainStagesEditor.vue?vue&type=script&lang=js"
import style0 from "./ChainStagesEditor.vue?vue&type=style&index=0&id=22a30096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a30096",
  null
  
)

export default component.exports